import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type { PostApiSearchparticipantResendVerificationCodeMutationResponse } from "../../../types/PostApiSearchparticipantResendVerificationCode";

export function getPostApiSearchparticipantResendVerificationCodeUrl() {
  return `/api/SearchParticipant/resend-verification-code` as const;
}

/**
 * {@link /api/SearchParticipant/resend-verification-code}
 */
export async function postApiSearchparticipantResendVerificationCode(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiSearchparticipantResendVerificationCodeMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: getPostApiSearchparticipantResendVerificationCodeUrl().toString(),
    ...requestConfig,
  });
  return res;
}
